// @flow
import styled from 'styled-components';
import DefaultTheme from '.';
import { se300, mercuryGrey } from '../../../colors';
/*::
import type { PrimaryButtonThemeType } from '.';
*/

var theme
/*: PrimaryButtonThemeType */
= Object.assign({}, DefaultTheme, {
  Button: styled(DefaultTheme.Button).withConfig({
    displayName: "shipa-ecommerce__Button",
    componentId: "okd724-0"
  })(["background:", ";"], function (pr) {
    return pr.disabled ? mercuryGrey() : se300();
  })
});
export default theme;